(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[163],{

/***/ 20724:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(61268));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M11.67 3.87 9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"
}), 'ArrowBackIos');

exports.Z = _default;

/***/ }),

/***/ 13379:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(61268));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M6.23 20.23 8 22l10-10L8 2 6.23 3.77 14.46 12z"
}), 'ArrowForwardIos');

exports.Z = _default;

/***/ }),

/***/ 61268:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "default", ({
  enumerable: true,
  get: function () {
    return _utils.createSvgIcon;
  }
}));

var _utils = __webpack_require__(26362);

/***/ }),

/***/ 6585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(32793);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1048);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_transition_group__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98885);
/* harmony import */ var _styles_useTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2734);
/* harmony import */ var _transitions_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30577);
/* harmony import */ var _utils_useForkRef__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51705);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
'use client';



const _excluded = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];








const styles = {
  entering: {
    transform: 'none'
  },
  entered: {
    transform: 'none'
  }
};

/**
 * The Zoom transition can be used for the floating variant of the
 * [Button](/material-ui/react-button/#floating-action-buttons) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */
const Zoom = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Zoom(props, ref) {
  const theme = (0,_styles_useTheme__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  const defaultTimeout = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };
  const {
      addEndListener,
      appear = true,
      children,
      easing,
      in: inProp,
      onEnter,
      onEntered,
      onEntering,
      onExit,
      onExited,
      onExiting,
      style,
      timeout = defaultTimeout,
      // eslint-disable-next-line react/prop-types
      TransitionComponent = react_transition_group__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP
    } = props,
    other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, _excluded);
  const nodeRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  const handleRef = (0,_utils_useForkRef__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(nodeRef, children.ref, ref);
  const normalizedTransitionCallback = callback => maybeIsAppearing => {
    if (callback) {
      const node = nodeRef.current;

      // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
      if (maybeIsAppearing === undefined) {
        callback(node);
      } else {
        callback(node, maybeIsAppearing);
      }
    }
  };
  const handleEntering = normalizedTransitionCallback(onEntering);
  const handleEnter = normalizedTransitionCallback((node, isAppearing) => {
    (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_6__/* .reflow */ .n)(node); // So the animation always start from the start.

    const transitionProps = (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_6__/* .getTransitionProps */ .C)({
      style,
      timeout,
      easing
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
    node.style.transition = theme.transitions.create('transform', transitionProps);
    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback(onEntered);
  const handleExiting = normalizedTransitionCallback(onExiting);
  const handleExit = normalizedTransitionCallback(node => {
    const transitionProps = (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_6__/* .getTransitionProps */ .C)({
      style,
      timeout,
      easing
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
    node.style.transition = theme.transitions.create('transform', transitionProps);
    if (onExit) {
      onExit(node);
    }
  });
  const handleExited = normalizedTransitionCallback(onExited);
  const handleAddEndListener = next => {
    if (addEndListener) {
      // Old call signature before `react-transition-group` implemented `nodeRef`
      addEndListener(nodeRef.current, next);
    }
  };
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TransitionComponent, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
    appear: appear,
    in: inProp,
    nodeRef: nodeRef,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    timeout: timeout
  }, other, {
    children: (state, childProps) => {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        style: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
          transform: 'scale(0)',
          visibility: state === 'exited' && !inProp ? 'hidden' : undefined
        }, styles[state], style, children.props.style),
        ref: handleRef
      }, childProps));
    }
  }));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (Zoom);

/***/ }),

/***/ 26362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "capitalize": function() { return /* reexport */ capitalize/* default */.Z; },
  "createChainedFunction": function() { return /* reexport */ createChainedFunction/* default */.Z; },
  "createSvgIcon": function() { return /* reexport */ createSvgIcon/* default */.Z; },
  "debounce": function() { return /* reexport */ debounce/* default */.Z; },
  "deprecatedPropType": function() { return /* reexport */ utils_deprecatedPropType; },
  "isMuiElement": function() { return /* reexport */ isMuiElement/* default */.Z; },
  "ownerDocument": function() { return /* reexport */ ownerDocument/* default */.Z; },
  "ownerWindow": function() { return /* reexport */ ownerWindow/* default */.Z; },
  "requirePropFactory": function() { return /* reexport */ utils_requirePropFactory; },
  "setRef": function() { return /* reexport */ utils_setRef; },
  "unstable_ClassNameGenerator": function() { return /* binding */ unstable_ClassNameGenerator; },
  "unstable_useEnhancedEffect": function() { return /* reexport */ useEnhancedEffect/* default */.Z; },
  "unstable_useId": function() { return /* reexport */ useId/* default */.Z; },
  "unsupportedProp": function() { return /* reexport */ utils_unsupportedProp; },
  "useControlled": function() { return /* reexport */ useControlled/* default */.Z; },
  "useEventCallback": function() { return /* reexport */ useEventCallback/* default */.Z; },
  "useForkRef": function() { return /* reexport */ useForkRef/* default */.Z; },
  "useIsFocusVisible": function() { return /* reexport */ useIsFocusVisible/* default */.Z; }
});

// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/ClassNameGenerator/ClassNameGenerator.js
var ClassNameGenerator = __webpack_require__(18356);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/createChainedFunction.js
var createChainedFunction = __webpack_require__(35893);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(82066);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/debounce.js
var debounce = __webpack_require__(57144);
;// CONCATENATED MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/deprecatedPropType.js
function deprecatedPropType(validator, reason) {
  if (true) {
    return () => null;
  }
  return (props, propName, componentName, location, propFullName) => {
    const componentNameSafe = componentName || '<<anonymous>>';
    const propFullNameSafe = propFullName || propName;
    if (typeof props[propName] !== 'undefined') {
      return new Error(`The ${location} \`${propFullNameSafe}\` of ` + `\`${componentNameSafe}\` is deprecated. ${reason}`);
    }
    return null;
  };
}
;// CONCATENATED MODULE: ./node_modules/@mui/material/utils/deprecatedPropType.js

/* harmony default export */ var utils_deprecatedPropType = (deprecatedPropType);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/isMuiElement.js + 1 modules
var isMuiElement = __webpack_require__(29314);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/ownerDocument.js
var ownerDocument = __webpack_require__(8038);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/ownerWindow.js
var ownerWindow = __webpack_require__(5340);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(32793);
;// CONCATENATED MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/requirePropFactory.js

function requirePropFactory(componentNameInError, Component) {
  if (true) {
    return () => null;
  }

  // eslint-disable-next-line react/forbid-foreign-prop-types
  const prevPropTypes = Component ? (0,esm_extends/* default */.Z)({}, Component.propTypes) : null;
  const requireProp = requiredProp => (props, propName, componentName, location, propFullName, ...args) => {
    const propFullNameSafe = propFullName || propName;
    const defaultTypeChecker = prevPropTypes == null ? void 0 : prevPropTypes[propFullNameSafe];
    if (defaultTypeChecker) {
      const typeCheckerResult = defaultTypeChecker(props, propName, componentName, location, propFullName, ...args);
      if (typeCheckerResult) {
        return typeCheckerResult;
      }
    }
    if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
      return new Error(`The prop \`${propFullNameSafe}\` of ` + `\`${componentNameInError}\` can only be used together with the \`${requiredProp}\` prop.`);
    }
    return null;
  };
  return requireProp;
}
;// CONCATENATED MODULE: ./node_modules/@mui/material/utils/requirePropFactory.js

/* harmony default export */ var utils_requirePropFactory = (requirePropFactory);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/setRef.js
var setRef = __webpack_require__(88666);
;// CONCATENATED MODULE: ./node_modules/@mui/material/utils/setRef.js

/* harmony default export */ var utils_setRef = (setRef/* default */.Z);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useEnhancedEffect.js
var useEnhancedEffect = __webpack_require__(58974);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useId.js
var useId = __webpack_require__(27909);
;// CONCATENATED MODULE: ./node_modules/@mui/material/node_modules/@mui/utils/esm/unsupportedProp.js
function unsupportedProp(props, propName, componentName, location, propFullName) {
  if (true) {
    return null;
  }
  const propFullNameSafe = propFullName || propName;
  if (typeof props[propName] !== 'undefined') {
    return new Error(`The prop \`${propFullNameSafe}\` is not supported. Please remove it.`);
  }
  return null;
}
;// CONCATENATED MODULE: ./node_modules/@mui/material/utils/unsupportedProp.js

/* harmony default export */ var utils_unsupportedProp = (unsupportedProp);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useControlled.js
var useControlled = __webpack_require__(49299);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useEventCallback.js
var useEventCallback = __webpack_require__(2068);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useForkRef.js
var useForkRef = __webpack_require__(51705);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/useIsFocusVisible.js + 1 modules
var useIsFocusVisible = __webpack_require__(65294);
;// CONCATENATED MODULE: ./node_modules/@mui/material/utils/index.js
'use client';



















// TODO: remove this export once ClassNameGenerator is stable
// eslint-disable-next-line @typescript-eslint/naming-convention
const unstable_ClassNameGenerator = {
  configure: generator => {
    if (false) {}
    ClassNameGenerator/* default.configure */.Z.configure(generator);
  }
};

/***/ }),

/***/ 76864:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cinemas/[slug]",
      function () {
        return __webpack_require__(10640);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 16504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IconLocation */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86896);
/* harmony import */ var _image_box_future__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58718);



var locationIcon = "/icons/shared/location-icon-blue.svg";
var IconLocation = function() {
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_image_box_future__WEBPACK_IMPORTED_MODULE_1__/* .ImageBoxFuture */ .z, {
        img: locationIcon,
        title: intl.formatMessage({
            id: "images.title.location"
        }),
        objectFit: "contain",
        debug: false,
        sx: {
            width: "24px",
            height: "24px"
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconLocation);


/***/ }),

/***/ 71192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ LottiePlayer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36822);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);



var Lottie = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(296), __webpack_require__.e(9260)]).then(__webpack_require__.t.bind(__webpack_require__, 69260, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69260)
            ];
        }
    },
    ssr: false
});
var LottiePlayer = function(param) {
    var boxSx = param.boxSx, animationData = param.animationData;
    return animationData && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        sx: boxSx,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Lottie, {
            animationData: animationData,
            loop: true
        })
    });
};


/***/ }),

/***/ 75884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ MovieLoaderWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(36822);
// EXTERNAL MODULE: ./src/components/shared/lottie-player.tsx
var lottie_player = __webpack_require__(71192);
;// CONCATENATED MODULE: ./src/lotties/movieLoader.json
var movieLoader_namespaceObject = JSON.parse('{"nm":"Comp 1","mn":"","layers":[{"ty":3,"nm":"Null 1","mn":"","sr":1,"st":0,"op":120,"ip":0,"hd":false,"cl":"","ln":"","ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[960,540,0],"ix":2},"sa":{"a":0,"k":0},"o":{"a":0,"k":0,"ix":11},"r":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.294,"y":1},"s":[0],"t":0},{"o":{"x":0.655,"y":0},"i":{"x":0.667,"y":1},"s":[360],"t":60},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[720],"t":117.5}],"ix":10}},"ef":[],"ind":1},{"ty":4,"nm":"Ellipse 4","mn":"","sr":1,"st":0,"op":120,"ip":0,"hd":false,"cl":"","ln":"","ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0,0,0],"t":0},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[-134,134,0],"t":60},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0,0,0],"t":117.5}],"ix":2},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[80],"t":0},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":60},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[80],"t":117.5}],"ix":11},"r":{"a":0,"k":0,"ix":10}},"ef":[],"shapes":[{"ty":"gr","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 4 Stroke","ix":1,"cix":2,"np":3,"it":[{"ty":"el","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[118,118],"ix":2}},{"ty":"op","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Filter - Offset","nm":"Offset Paths 1","ix":3,"a":{"a":0,"k":-0.5,"ix":1},"lj":1,"ml":{"a":0,"k":4,"ix":3}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]},{"ty":"gr","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 4 Fill","ix":2,"cix":2,"np":2,"it":[{"ty":"el","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[118,118],"ix":2}},{"ty":"fl","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.8196,0.6667,0.8431],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":2,"parent":1},{"ty":4,"nm":"Ellipse 3","mn":"","sr":1,"st":0,"op":120,"ip":0,"hd":false,"cl":"","ln":"","ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0,0,0],"t":0},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[134,134,0],"t":60},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0,0,0],"t":117.5}],"ix":2},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[80],"t":0},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":60},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[80],"t":117.5}],"ix":11},"r":{"a":0,"k":0,"ix":10}},"ef":[],"shapes":[{"ty":"gr","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 3 Stroke","ix":1,"cix":2,"np":3,"it":[{"ty":"el","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[118,118],"ix":2}},{"ty":"op","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Filter - Offset","nm":"Offset Paths 1","ix":3,"a":{"a":0,"k":-0.5,"ix":1},"lj":1,"ml":{"a":0,"k":4,"ix":3}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]},{"ty":"gr","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 3 Fill","ix":2,"cix":2,"np":2,"it":[{"ty":"el","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[118,118],"ix":2}},{"ty":"fl","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.549,0.1725,0.6078],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":3,"parent":1},{"ty":4,"nm":"Ellipse 2","mn":"","sr":1,"st":0,"op":120,"ip":0,"hd":false,"cl":"","ln":"","ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0,0,0],"t":0},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[134,-134,0],"t":60},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0,0,0],"t":117.5}],"ix":2},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[80],"t":0},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":60},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[80],"t":117.5}],"ix":11},"r":{"a":0,"k":0,"ix":10}},"ef":[],"shapes":[{"ty":"gr","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 2 Stroke","ix":1,"cix":2,"np":3,"it":[{"ty":"el","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[118,118],"ix":2}},{"ty":"op","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Filter - Offset","nm":"Offset Paths 1","ix":3,"a":{"a":0,"k":-0.5,"ix":1},"lj":1,"ml":{"a":0,"k":4,"ix":3}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]},{"ty":"gr","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 2 Fill","ix":2,"cix":2,"np":2,"it":[{"ty":"el","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[118,118],"ix":2}},{"ty":"fl","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.7333,0.502,0.7686],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":4,"parent":1},{"ty":4,"nm":"Ellipse 1","mn":"","sr":1,"st":0,"op":120,"ip":0,"hd":false,"cl":"","ln":"","ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0,0,0],"t":0},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[-134,-134,0],"t":60},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0,0,0],"t":117.5}],"ix":2},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.188,"y":1},"s":[80],"t":0},{"o":{"x":0.899,"y":-0.919},"i":{"x":0.667,"y":1},"s":[100],"t":60},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[80],"t":117.5}],"ix":11},"r":{"a":0,"k":0,"ix":10}},"ef":[],"shapes":[{"ty":"gr","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 1 Stroke","ix":1,"cix":2,"np":3,"it":[{"ty":"el","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[118,118],"ix":2}},{"ty":"op","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Filter - Offset","nm":"Offset Paths 1","ix":3,"a":{"a":0,"k":-0.5,"ix":1},"lj":1,"ml":{"a":0,"k":4,"ix":3}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]},{"ty":"gr","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 1 Fill","ix":2,"cix":2,"np":2,"it":[{"ty":"el","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[118,118],"ix":2}},{"ty":"fl","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.549,0.1725,0.6078],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":5,"parent":1}],"ddd":0,"h":1080,"w":1920,"meta":{"a":"","k":"","d":"","g":"LottieFiles AE 1.1.0","tc":"#000000"},"v":"4.8.0","fr":60,"op":120,"ip":0,"assets":[]}');
;// CONCATENATED MODULE: ./src/components/shared/movie-loader-wrapper.tsx




var MovieLoaderWrapper = function(param) {
    var innerBox = param.innerBox, outerBox = param.outerBox;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: outerBox,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lottie_player/* LottiePlayer */.V, {
            animationData: movieLoader_namespaceObject,
            boxSx: innerBox
        })
    });
};


/***/ }),

/***/ 47488:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "gr": function() { return /* reexport */ useGetCinemaDetails; },
  "ve": function() { return /* reexport */ useGetCinemaList; },
  "L8": function() { return /* reexport */ useGetCinemas; }
});

// UNUSED EXPORTS: getCinemaList, useGetCinema

// EXTERNAL MODULE: ./src/logic/libs/index.ts
var libs = __webpack_require__(81900);
// EXTERNAL MODULE: ./src/constants/cashing.ts
var cashing = __webpack_require__(29236);
;// CONCATENATED MODULE: ./src/logic/services/cinemas/services.ts



var url = "cinemas";
var getCinemaList = function(params) {
    var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return axiosInstance.get("".concat(url), _object_spread({
        params: params
    }, config)).then(function(res) {
        return res === null || res === void 0 ? void 0 : res.data;
    });
};
var useGetCinemaList = (0,libs/* createQuery */.rP)({
    url: "".concat(url),
    method: "get"
}, {
    staleTime: cashing/* long_term_cashing */.d,
    keepPreviousData: false
});
var useGetCinemaDetails = (0,libs/* createQuery */.rP)({
    method: "get",
    url: "".concat(url, "/unique-name/:slug")
});
var useGetCinemas = (0,libs/* createQuery */.rP)({
    method: "get",
    url: "".concat(url)
}, {
    staleTime: cashing/* long_term_cashing */.d,
    keepPreviousData: false
});
var useGetCinema = (0,libs/* createQuery */.rP)({
    method: "get",
    url: "".concat(url, "/unique-name/:slug")
});

;// CONCATENATED MODULE: ./src/logic/services/cinemas/index.ts




/***/ }),

/***/ 10640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CinemaDetails": function() { return /* binding */ CinemaDetails; },
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(36822);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./src/logic/services/cinemas/index.ts + 1 modules
var cinemas = __webpack_require__(47488);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js
var IconButton = __webpack_require__(54799);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 94 modules
var swiper_esm = __webpack_require__(88116);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./src/constants/prefetch.ts
var prefetch = __webpack_require__(86650);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowBackIos.js
var ArrowBackIos = __webpack_require__(20724);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowForwardIos.js
var ArrowForwardIos = __webpack_require__(13379);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/lang/utils.ts
var utils = __webpack_require__(61671);
// EXTERNAL MODULE: ./src/theme/typography.ts
var typography = __webpack_require__(43795);
// EXTERNAL MODULE: ./src/logic/hooks/index.ts + 27 modules
var hooks = __webpack_require__(7663);
// EXTERNAL MODULE: ./node_modules/next/dist/client/router.js
var router = __webpack_require__(90387);
// EXTERNAL MODULE: ./src/components/shared/image-box-future.tsx
var image_box_future = __webpack_require__(58718);
;// CONCATENATED MODULE: ./src/components/cinema/experiences-slider.tsx













var ExperiencesSlider = function(experiencesProps) {
    var ref, ref1, ref2;
    var theme = (0,useTheme/* default */.Z)();
    var locale = (0,router.useRouter)().locale;
    var isRtl = (0,utils/* checkIsRtl */.TM)(locale);
    var ref3 = (0,hooks/* useCity */.hA)(), browserCityId = ref3.cityId;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            display: "flex",
            justifyContent: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            component: "div",
            sx: {
                overflow: "visible",
                ".swiper": {
                    width: {
                        tablet: "165vw",
                        mobile: "200vw"
                    },
                    pt: (0,typography/* pxToRem */.Q)(32),
                    overflow: "visible"
                },
                "& .swiper-slide.swiper-slide-active  div.MuiBox-root ": {
                    "& img": {
                        filter: "drop-shadow(4px 0px 18px rgba(0, 0, 0, 0.3)) drop-shadow(-4px 0px 18px rgba(0, 0, 0, 0.3));"
                    },
                    "& a": {
                        display: "flex "
                    }
                },
                "& .swiper-slide.swiper-slide-active  div.MuiBox-root::after, .swiper-slide div.MuiBox-root div.MuiBox-root::after": {
                    width: "0%"
                },
                "& .swiper-slide": {
                    "a": {
                        display: "none"
                    }
                },
                "& .swiper-pagination-bullet": {
                    width: {
                        tablet: (0,typography/* pxToRem */.Q)(12),
                        mobile: "6px"
                    },
                    height: {
                        tablet: (0,typography/* pxToRem */.Q)(12),
                        mobile: "6px"
                    },
                    background: theme.palette.grey[30],
                    backdropFilter: " blur(5px)",
                    borderRadius: "100%",
                    mx: (0,typography/* pxToRem */.Q)(6),
                    cursor: "pointer"
                },
                "& .swiper-pagination-bullet-active": {
                    background: theme.palette.primary.main,
                    border: "1px solid ".concat(theme.palette.primary.main),
                    width: {
                        tablet: (0,typography/* pxToRem */.Q)(14),
                        mobile: "8px"
                    },
                    height: {
                        tablet: (0,typography/* pxToRem */.Q)(14),
                        mobile: "8px"
                    }
                },
                "& .swiper-pagination": {
                    display: "flex",
                    justifyContent: "center",
                    mt: (0,typography/* pxToRem */.Q)(24),
                    mb: {
                        tablet: (0,typography/* pxToRem */.Q)(48),
                        mobile: "16px"
                    },
                    position: "static",
                    alignItems: "center"
                }
            },
            children: experiencesProps.experiences.length !== 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                spaceBetween: 0,
                slidesPerView: 3,
                modules: [
                    swiper_esm/* EffectCoverflow */.lI,
                    swiper_esm/* Pagination */.tl
                ],
                pagination: {
                    clickable: true
                },
                scrollbar: {
                    draggable: true
                },
                centeredSlides: true,
                slideToClickedSlide: true,
                loop: experiencesProps.experiences.length !== 1,
                coverflowEffect: {
                    depth: 0,
                    rotate: 0,
                    scale: 0.8,
                    slideShadows: false
                },
                speed: 600,
                effect: "coverflow",
                children: experiencesProps.experiences.map(function(item) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            component: "div",
                            sx: {
                                position: "relative",
                                cursor: "pointer",
                                "::after": {
                                    content: "''",
                                    position: "absolute",
                                    width: "100%",
                                    height: "100%",
                                    background: "rgba(0, 0, 0, 0.42)",
                                    backdropFilter: " blur(5px)",
                                    left: 0,
                                    borderRadius: "20px",
                                    overflow: "hidden",
                                    cursor: "grab",
                                    top: 0
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                                    img: item.cover,
                                    title: (item === null || item === void 0 ? void 0 : item.coverAlt) || item.name,
                                    layout: "intrinsic",
                                    objectFit: "cover",
                                    width: "1920px",
                                    height: "1080px",
                                    sx: {
                                        borderRadius: "20px",
                                        overflow: "hidden"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    component: "div",
                                    sx: {
                                        display: "flex",
                                        position: "absolute",
                                        bottom: 0,
                                        height: {
                                            tablet: "".concat((0,typography/* pxToRem */.Q)(130), " !important"),
                                            mobile: "60px !important"
                                        },
                                        p: {
                                            tablet: (0,typography/* pxToRem */.Q)(32),
                                            mobile: "12px"
                                        },
                                        background: "linear-gradient(180deg, rgba(0, 0, 0, 0.04) 0%, rgba(0, 0, 0, 0.468) 23.23%, #000000 77.4%)",
                                        borderRadius: "0px 0px 20px 20px",
                                        width: " 100%",
                                        justifyContent: "space-between",
                                        alignItems: {
                                            tablet: "flexEnd",
                                            mobile: "flex-end"
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: {
                                            pathname: "/experiences/".concat(item.uniqueName),
                                            query: {
                                                cityId: browserCityId
                                            }
                                        },
                                        prefetch: prefetch/* ALLOW_EXPERIENCE_DETAILS_PREFETCH */.xi,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                            sx: {
                                                width: {
                                                    tablet: (0,typography/* pxToRem */.Q)(64),
                                                    mobile: "34px"
                                                },
                                                height: {
                                                    tablet: (0,typography/* pxToRem */.Q)(64),
                                                    mobile: "34px"
                                                },
                                                background: theme.palette.common.white,
                                                ml: "auto"
                                            },
                                            children: isRtl ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBackIos/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForwardIos/* default */.Z, {})
                                        })
                                    })
                                })
                            ]
                        }, item.id)
                    }, item.id);
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                component: "div",
                sx: {
                    // height: { tablet: pxToRem(610 + 50), mobile: '125px' },
                    m: "auto",
                    position: "relative",
                    width: "50%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                        img: (ref = experiencesProps.experiences[0]) === null || ref === void 0 ? void 0 : ref.cover,
                        title: (ref1 = experiencesProps.experiences[0]) === null || ref1 === void 0 ? void 0 : ref1.coverAlt,
                        layout: "intrinsic",
                        objectFit: "cover",
                        width: "1920px",
                        height: "1080px",
                        sx: {
                            // maxWidth: '100%',
                            // width: '100%',
                            // height: '100%',
                            // objectFit: 'cover',
                            borderRadius: "20px",
                            overflow: "hidden",
                            position: "relative"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        component: "div",
                        sx: {
                            // display: 'flex',
                            position: "absolute",
                            bottom: {
                                tablet: (0,typography/* pxToRem */.Q)(32),
                                mobile: "12px"
                            },
                            right: {
                                tablet: (0,typography/* pxToRem */.Q)(32),
                                mobile: "12px"
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: {
                                pathname: "/experiences/".concat((ref2 = experiencesProps === null || experiencesProps === void 0 ? void 0 : experiencesProps.experiences[0]) === null || ref2 === void 0 ? void 0 : ref2.uniqueName),
                                // pathname: `/experiences/${experiencesProps?.experiences[0]?.id}`,
                                query: {
                                    cityId: browserCityId
                                }
                            },
                            passHref: true,
                            prefetch: prefetch/* ALLOW_EXPERIENCE_DETAILS_PREFETCH */.xi,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                sx: {
                                    width: {
                                        tablet: (0,typography/* pxToRem */.Q)(64),
                                        mobile: "34px"
                                    },
                                    height: {
                                        tablet: (0,typography/* pxToRem */.Q)(64),
                                        mobile: "34px"
                                    },
                                    background: theme.palette.common.white,
                                    ml: "auto"
                                },
                                children: isRtl ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBackIos/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForwardIos/* default */.Z, {})
                            })
                        })
                    })
                ]
            }, experiencesProps.experiences[0].id)
        })
    });
};
/* harmony default export */ var experiences_slider = (ExperiencesSlider);

// EXTERNAL MODULE: ./node_modules/@react-google-maps/api/dist/esm.js
var esm = __webpack_require__(37054);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
;// CONCATENATED MODULE: ./src/components/shared/map.tsx





var mapLocation = "/icons/cinema/mapLocation.svg";
var GoogleMaps = function(props) {
    // https://react-google-maps-api-docs.netlify.app/
    var lat = props.lat, long = props.long, zoom = props.zoom;
    var publicRuntimeConfig = config_default()().publicRuntimeConfig;
    var isLoaded = (0,esm/* useLoadScript */.Db)({
        googleMapsApiKey: publicRuntimeConfig.mapKey
    }).isLoaded;
    var center = {
        lat: lat,
        lng: long
    };
    return isLoaded ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* GoogleMap */.b6, {
        center: center,
        zoom: zoom !== null && zoom !== void 0 ? zoom : 8,
        mapContainerStyle: {
            height: "100%",
            width: "100%",
            borderRadius: "20px",
            overflow: "hidden"
        },
        options: {
            zoomControlOptions: {
                position: 9.0
            },
            streetViewControl: false,
            mapTypeControl: false
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Marker */.Jx, {
            position: center,
            icon: mapLocation
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {});
};
/* harmony default export */ var map = (GoogleMaps);

// EXTERNAL MODULE: ./src/components/shared/icon-location.tsx
var icon_location = __webpack_require__(16504);
// EXTERNAL MODULE: ./src/constants/movie-types-enum.ts
var movie_types_enum = __webpack_require__(15432);
// EXTERNAL MODULE: ./src/components/shared/movies-list.tsx + 1 modules
var movies_list = __webpack_require__(23944);
// EXTERNAL MODULE: ./src/components/seo/seo.tsx
var seo = __webpack_require__(89183);
// EXTERNAL MODULE: ./src/logic/services/index.ts + 21 modules
var services = __webpack_require__(10029);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/shared/movie-loader-wrapper.tsx + 1 modules
var movie_loader_wrapper = __webpack_require__(75884);
;// CONCATENATED MODULE: ./src/pages/cinemas/[slug].tsx


















var EmptyCinemaImgCard = "/icons/cinema/emptyCinemaImgCard.svg";
var paginationShowing = {
    limit: 4,
    page: 1
};
var __N_SSP = true;
var CinemaDetails = function(param) {
    var path = param.path;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22;
    var router = (0,next_router.useRouter)();
    var ref23 = (0,hooks/* useCity */.hA)(), browserCityId = ref23.cityId;
    var cityId = +router.query.cityId || browserCityId;
    var theme = (0,useTheme/* default */.Z)();
    var intl = (0,useIntl/* default */.Z)();
    var ref24 = (0,cinemas/* useGetCinemaDetails */.gr)({
        query: {
            slug: router.query.slug
        },
        params: {
            cityId: cityId
        }
    }), pageData = ref24.data, isLoading = ref24.isLoading;
    var ref25 = (0,services/* useGetInfiniteMovies */.$3)({
        params: {
            cinemaIds: [
                pageData === null || pageData === void 0 ? void 0 : (ref = pageData.cinema) === null || ref === void 0 ? void 0 : ref.id
            ],
            cityId: cityId,
            limit: paginationShowing.limit,
            page: paginationShowing.page,
            type: movie_types_enum/* MovieTypesEnum.SHOW_NOW */.g.SHOW_NOW
        }
    }), data = ref25.data, fetchNextPage = ref25.fetchNextPage, hasNextPage = ref25.hasNextPage, isFetching = ref25.isFetching, isFetchingNextPage = ref25.isFetchingNextPage;
    var movies = (0,react.useMemo)(function() {
        var ref;
        return (data === null || data === void 0 ? void 0 : data.pages) ? data === null || data === void 0 ? void 0 : (ref = data.pages) === null || ref === void 0 ? void 0 : ref.flatMap(function(group) {
            return group.data;
        }) : [];
    }, [
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* default */.Z, {
                title: (pageData === null || pageData === void 0 ? void 0 : (ref1 = pageData.cinema) === null || ref1 === void 0 ? void 0 : ref1.titleTag) || intl.formatMessage({
                    id: "cinema_details"
                }),
                canonical: pageData === null || pageData === void 0 ? void 0 : (ref2 = pageData.cinema) === null || ref2 === void 0 ? void 0 : ref2.canonicalURL,
                pagePath: path,
                description: (pageData === null || pageData === void 0 ? void 0 : (ref3 = pageData.cinema) === null || ref3 === void 0 ? void 0 : ref3.descriptionTag) || (pageData === null || pageData === void 0 ? void 0 : (ref4 = pageData.cinema) === null || ref4 === void 0 ? void 0 : ref4.description),
                image: pageData === null || pageData === void 0 ? void 0 : (ref5 = pageData.cinema) === null || ref5 === void 0 ? void 0 : ref5.image,
                noFollow: pageData === null || pageData === void 0 ? void 0 : (ref6 = pageData.cinema) === null || ref6 === void 0 ? void 0 : ref6.hasFollow,
                noIndex: pageData === null || pageData === void 0 ? void 0 : (ref7 = pageData.cinema) === null || ref7 === void 0 ? void 0 : ref7.hasIndex
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                component: "section",
                sx: {
                    flexGrow: 1,
                    mb: (0,typography/* pxToRem */.Q)(122),
                    "& h1,h2,h3,h4,h5": {
                        fontWeight: 700
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        component: "h1",
                        sx: (0,_define_property/* default */.Z)({
                            fontSize: (0,typography/* pxToRem */.Q)(30),
                            color: theme.palette.grey[80],
                            my: (0,typography/* pxToRem */.Q)(52),
                            fontWeight: 700,
                            px: {
                                laptop: (0,typography/* pxToRem */.Q)(128),
                                tablet: (0,typography/* pxToRem */.Q)(60),
                                mobile: "18px"
                            },
                            maxWidth: "1920px",
                            mx: "auto"
                        }, theme.breakpoints.down("tablet"), {
                            mt: "32px",
                            mb: "24px"
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "cinema_details"
                        })
                    }),
                    !isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        component: "div",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                                img: (pageData === null || pageData === void 0 ? void 0 : (ref8 = pageData.cinema) === null || ref8 === void 0 ? void 0 : ref8.coverUrl) || EmptyCinemaImgCard,
                                title: (pageData === null || pageData === void 0 ? void 0 : (ref9 = pageData.cinema) === null || ref9 === void 0 ? void 0 : ref9.coverUrlAlt) || (pageData === null || pageData === void 0 ? void 0 : (ref10 = pageData.cinema) === null || ref10 === void 0 ? void 0 : ref10.name),
                                layout: "intrinsic",
                                objectFit: "cover",
                                width: "1920px",
                                height: "1080px",
                                sx: {
                                    marginBottom: (0,typography/* pxToRem */.Q)(32)
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                component: "div",
                                sx: {
                                    px: {
                                        laptop: (0,typography/* pxToRem */.Q)(128),
                                        tablet: (0,typography/* pxToRem */.Q)(60),
                                        mobile: "16px"
                                    },
                                    maxWidth: "1920px",
                                    mx: "auto",
                                    mb: (0,typography/* pxToRem */.Q)(48)
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        component: "article",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                gutterBottom: true,
                                                component: "h2",
                                                sx: {
                                                    fontSize: {
                                                        tablet: (0,typography/* pxToRem */.Q)(28),
                                                        mobile: "18px"
                                                    },
                                                    mb: (0,typography/* pxToRem */.Q)(16),
                                                    color: theme.palette.grey[90]
                                                },
                                                children: pageData === null || pageData === void 0 ? void 0 : (ref11 = pageData.cinema) === null || ref11 === void 0 ? void 0 : ref11.name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                component: "div",
                                                sx: {
                                                    display: "flex",
                                                    mb: (0,typography/* pxToRem */.Q)(48)
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_location/* default */.Z, {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        gutterBottom: true,
                                                        component: "address",
                                                        sx: {
                                                            mx: (0,typography/* pxToRem */.Q)(12),
                                                            fontSize: {
                                                                tablet: (0,typography/* pxToRem */.Q)(24),
                                                                mobile: "16px"
                                                            },
                                                            color: theme.palette.grey[50]
                                                        },
                                                        children: pageData === null || pageData === void 0 ? void 0 : (ref12 = pageData.cinema) === null || ref12 === void 0 ? void 0 : ref12.address1
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        component: "article",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                component: "h4",
                                                sx: {
                                                    fontSize: {
                                                        tablet: (0,typography/* pxToRem */.Q)(24),
                                                        mobile: "16px"
                                                    },
                                                    color: theme.palette.grey[90],
                                                    mb: (0,typography/* pxToRem */.Q)(32)
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                    id: "cinema_details.about"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "body1",
                                                color: "text.secondary",
                                                sx: {
                                                    fontSize: {
                                                        tablet: (0,typography/* pxToRem */.Q)(24),
                                                        mobile: "16px"
                                                    },
                                                    color: theme.palette.grey[50],
                                                    maxWidth: "1096px",
                                                    lineHeight: "150%"
                                                },
                                                children: pageData === null || pageData === void 0 ? void 0 : (ref13 = pageData.cinema) === null || ref13 === void 0 ? void 0 : ref13.description
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                component: "div",
                                sx: {
                                    overflow: "hidden"
                                },
                                children: [
                                    (pageData === null || pageData === void 0 ? void 0 : (ref14 = pageData.cinema) === null || ref14 === void 0 ? void 0 : ref14.experiences.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                component: "h4",
                                                sx: {
                                                    fontSize: {
                                                        tablet: (0,typography/* pxToRem */.Q)(24),
                                                        mobile: "16px"
                                                    },
                                                    color: theme.palette.grey[90],
                                                    px: {
                                                        laptop: (0,typography/* pxToRem */.Q)(128),
                                                        tablet: (0,typography/* pxToRem */.Q)(60),
                                                        mobile: "16px"
                                                    }
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                    id: "cinema_details.available_experiences"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(experiences_slider, {
                                                experiences: pageData === null || pageData === void 0 ? void 0 : (ref15 = pageData.cinema) === null || ref15 === void 0 ? void 0 : ref15.experiences
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        component: "div",
                                        sx: {
                                            px: {
                                                laptop: (0,typography/* pxToRem */.Q)(128),
                                                tablet: (0,typography/* pxToRem */.Q)(60),
                                                mobile: "16px"
                                            },
                                            py: {
                                                laptop: (0,typography/* pxToRem */.Q)(128),
                                                tablet: (0,typography/* pxToRem */.Q)(60),
                                                mobile: "16px"
                                            }
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                component: "div",
                                                sx: {
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    flexWrap: "wrap",
                                                    alignItems: "flex-end"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                        component: "div",
                                                        sx: {
                                                            display: "flex",
                                                            mb: {
                                                                tablet: (0,typography/* pxToRem */.Q)(33),
                                                                mobile: "16px"
                                                            }
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_location/* default */.Z, {}),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                gutterBottom: true,
                                                                component: "h2",
                                                                sx: {
                                                                    fontSize: {
                                                                        tablet: (0,typography/* pxToRem */.Q)(24),
                                                                        mobile: "16px"
                                                                    },
                                                                    mx: (0,typography/* pxToRem */.Q)(12),
                                                                    color: theme.palette.grey[50],
                                                                    mb: 0
                                                                },
                                                                children: pageData === null || pageData === void 0 ? void 0 : (ref16 = pageData.cinema) === null || ref16 === void 0 ? void 0 : ref16.address2
                                                            })
                                                        ]
                                                    }),
                                                    (pageData === null || pageData === void 0 ? void 0 : (ref17 = pageData.cinema) === null || ref17 === void 0 ? void 0 : ref17.long) && (pageData === null || pageData === void 0 ? void 0 : (ref18 = pageData.cinema) === null || ref18 === void 0 ? void 0 : ref18.lat) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        gutterBottom: true,
                                                        component: "a",
                                                        sx: {
                                                            fontSize: (0,typography/* pxToRem */.Q)(24),
                                                            textDecoration: "none",
                                                            color: theme.palette.primary.main,
                                                            cursor: "pointer",
                                                            mb: {
                                                                tablet: (0,typography/* pxToRem */.Q)(33),
                                                                mobile: "16px"
                                                            }
                                                        },
                                                        onClick: function() {
                                                            var ref, ref1;
                                                            window.open("https://maps.google.com?q=" + (pageData === null || pageData === void 0 ? void 0 : (ref = pageData.cinema) === null || ref === void 0 ? void 0 : ref.lat) + "," + (pageData === null || pageData === void 0 ? void 0 : (ref1 = pageData.cinema) === null || ref1 === void 0 ? void 0 : ref1.long));
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                            id: "cinema_details.view_directions"
                                                        })
                                                    })
                                                ]
                                            }),
                                            (pageData === null || pageData === void 0 ? void 0 : (ref19 = pageData.cinema) === null || ref19 === void 0 ? void 0 : ref19.long) && (pageData === null || pageData === void 0 ? void 0 : (ref20 = pageData.cinema) === null || ref20 === void 0 ? void 0 : ref20.lat) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                component: "div",
                                                sx: {
                                                    height: {
                                                        tablet: (0,typography/* pxToRem */.Q)(941),
                                                        mobile: "152px"
                                                    },
                                                    width: "100%",
                                                    borderRadius: "20px",
                                                    overflow: "hidden"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(map, {
                                                    long: +(pageData === null || pageData === void 0 ? void 0 : (ref21 = pageData.cinema) === null || ref21 === void 0 ? void 0 : ref21.long),
                                                    lat: +(pageData === null || pageData === void 0 ? void 0 : (ref22 = pageData.cinema) === null || ref22 === void 0 ? void 0 : ref22.lat)
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            movies.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                component: "div",
                                sx: {
                                    px: {
                                        laptop: (0,typography/* pxToRem */.Q)(128),
                                        tablet: (0,typography/* pxToRem */.Q)(60),
                                        mobile: "16px"
                                    },
                                    maxWidth: "1920px",
                                    mx: "auto",
                                    mb: (0,typography/* pxToRem */.Q)(500)
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        component: "h4",
                                        sx: {
                                            fontSize: (0,typography/* pxToRem */.Q)(24),
                                            color: theme.palette.grey[90],
                                            mt: {
                                                tablet: (0,typography/* pxToRem */.Q)(48),
                                                mobile: "24px"
                                            },
                                            mb: {
                                                tablet: (0,typography/* pxToRem */.Q)(52),
                                                mobile: "16px"
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                            id: "cinema_details.movies_showing"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(movies_list/* default */.Z, {
                                        moviesList: movies,
                                        hasMore: hasNextPage,
                                        fetchMovies: fetchNextPage,
                                        isFetching: isFetching,
                                        isFetchingNextPage: isFetchingNextPage,
                                        sx: {
                                            mt: {
                                                mobile: "0px"
                                            }
                                        },
                                        itemListName: "Cinemas"
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(movie_loader_wrapper/* MovieLoaderWrapper */.Y, {
                        innerBox: (0,_define_property/* default */.Z)({
                            width: "160px",
                            height: "160px"
                        }, theme.breakpoints.down("laptop"), {
                            width: "100px",
                            height: "100px"
                        }),
                        outerBox: {
                            width: "100%",
                            height: {
                                mobile: "calc(100vh - 56px)",
                                tablet: "calc(100vh - 100px)"
                            },
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var _slug_ = (CinemaDetails);


/***/ }),

/***/ 64836:
/***/ (function(module) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1255,6886,4386,719,6102,9774,2888,179], function() { return __webpack_exec__(76864); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);